<style>

    .display{
        background-color: black;
        height: 100vh;
    }

    .lightbox{
        width: 90vw;
        height: 90vh;
    }

    #prev{
        position: fixed;
        top: 50%;
        left: 15px;
    }

    #next{
        position: fixed;
        top: 50%;
        right: 15px;
    }

    .close{
        position: fixed;
        top: 15%;
        right: 15px;
        border: 2px solid #fff;
        background-color: transparent;
        color: #fff;
        padding: 15px 15px;
        cursor: pointer;
        border-radius: 20%;
        outline: none;
    }

    .close:hover{
        background-color: red;
    }

    .buttons{
        border: 2px solid #fff;
        background-color: transparent;
        color: #fff;
        cursor: pointer;
        padding: 13px 15px;
        border-radius: 50%;
        outline: none;
    }

    .buttons:hover{
        background-color: #fff;
        color: #333;
    }


</style>

<script>
    import {mobile_menu} from '../../store.js';
    import { url } from '@sveltech/routify'

    var images = [
        {"src": "/img/dekor/1.jpg"},
        {"src": "/img/dekor/2.jpg"},
        {"src": "/img/dekor/3.jpg"},
        {"src": "/img/dekor/4.jpg"},
        {"src": "/img/dekor/5.jpg"},
        {"src": "/img/dekor/6.jpg"},
        {"src": "/img/dekor/7.jpg"},
        {"src": "/img/dekor/8.jpg"},
        {"src": "/img/dekor/9.jpg"},
        {"src": "/img/dekor/10.jpg"},
        {"src": "/img/dekor/11.jpg"},
    ];

    var page = 0;
    let menu = false;

    mobile_menu.subscribe((val) => menu = val);

    function next(){
        page = page + 1;
    }
    function prev(){
        page = page - 1;
    }
    </script>
<div class="display">
<div class="object-cover grid place-items-center">
    <div class="lightbox">
        {#each images as image, i}
            {#if i == page}
                <img src={image.src} class="object-contain w-full h-full" alt="galéria">
            {/if}
        {/each}
    </div>
</div>

{#if page != 0}
<button on:click={prev} class="buttons" id="prev"><i class="fas fa-arrow-left"></i></button>
{/if}

{#if page != images.length - 1}
<button on:click={next}  class="buttons" id="next"><i class="fas fa-arrow-right"></i></button>
{/if}
{#if menu == false}
<a href={$url("/")}><button class="close"><i class="fa-solid fa-xmark"></i></button></a>
{/if}
</div>